export enum EMaterielEauIntegrePhyto {
    BouteilleFermante = 1,
    BouteilleIntegratice = 2,
    Tuyau = 3,
    Pompe = 4
}